import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { URI } from '../../constants/URI';
import { setTemplates } from '../slices/templateSlice';
import { store } from '../store';

export const getTemplates = async ({ search } = {}) => {
  const res = await handleGetRequest(URI.template, null, {
    params: {
      search,
    },
  });
  if (res?.ack) store.dispatch(setTemplates(res?.data));
  return res;
};

export const createTemplate = async (body) => {
  const res = await handlePostRequest(URI.template, body);
  if (res?.ack) getTemplates();
  return res;
};

export const updateTemplate = async (body) => {
  const res = await handlePutRequest(URI.template_id(body?.id), body);
  if (res?.ack) getTemplates();
  return res;
};

export const deleteTemplate = async (id) => {
  const res = await handleDeleteRequest(URI.template_id(id), null);
  if (res?.ack) getTemplates();
  return res;
};
